import { Nullable, processUnionEntries } from '@mobalytics/shared';
import { SubscriptionT, SubscriptionUnionT } from '../payment.types';

export const getCurrentSubscription = (data: SubscriptionUnionT[] | undefined): Nullable<SubscriptionT> => {
  return processUnionEntries<SubscriptionT>(data, 'TreasuryPaymentsSubscription')?.find(
    (subscription) => subscription.nextPaymentDate && new Date(subscription.nextPaymentDate).getTime() >= Date.now()
  );
};
